import https from "./https"
import store from "@/store"

const organization = store.state.general.organization;

// 邀友入會活動 mgmCampaign
const mgmCampaign = {
  getMgmCampaigns(merchantId, params) {
    return https.get(
      `admin/organizations/${organization.id}/merchants/${merchantId}/mgm-campaigns`, 
      { params }
    );
  },

  createMgmCampaign(merchantId, params) {
    return https.post(
      `admin/organizations/${organization.id}/merchants/${merchantId}/mgm-campaigns`, 
      params
    );
  },

  getMgmCampaign(id) {
    return https.get(`admin/organizations/${organization.id}/mgm-campaigns/${id}`);
  },

  updateMgmCampaign(id, params) {
    return https.put(`admin/organizations/${organization.id}/mgm-campaigns/${id}`, params);
  },

  deleteMgmCampaign(id) {
    return https.delete(`admin/organizations/${organization.id}/mgm-campaigns/${id}`);
  },
}

export default mgmCampaign